"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.list.title': 'Tutorial',
    'tutorial.list.empty.title': 'Nessun Tutorial Trovato',
    'tutorial.list.empty.message': 'Crea il tuo primo tutorial per iniziare con esperienze di apprendimento interattive.',
    'tutorial.expired': 'Scaduto',
    'tutorial.draft': 'Bozza',
};
